import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ApprovalChainCard = ({ chain, onView, onEdit }) => {
  const statusColors = {
    active: 'bg-success/10 text-success border-success',
    inactive: 'bg-muted/10 text-muted-foreground border-muted',
    archived: 'bg-error/10 text-error border-error'
  };

  const entityTypeLabels = {
    leave_request: 'Leave Requests',
    payroll_batch: 'Payroll Batches',
    contract: 'Contracts',
    expense: 'Expenses'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="text-lg font-semibold text-foreground">
              {chain?.templateName}
            </h3>
            {chain?.isDefault && (
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded">
                Default
              </span>
            )}
            <span className={`px-3 py-1 rounded-full text-xs font-medium border ${statusColors?.[chain?.chainStatus]}`}>
              {chain?.chainStatus?.toUpperCase()}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-2">
            {chain?.description}
          </p>
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <span className="flex items-center gap-1">
              <Icon name="FileText" size={14} />
              {entityTypeLabels?.[chain?.entityType] || chain?.entityType}
            </span>
            <span className="flex items-center gap-1">
              <Icon name="User" size={14} />
              Created by {chain?.createdBy}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3 pt-4 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          iconName="Eye"
          onClick={() => onView?.(chain?.id)}
        >
          View Details
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          onClick={() => onEdit?.(chain?.id)}
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

export default ApprovalChainCard;